{
  "info": "Teave",
  "negative": "Viga",
  "notice": "Hoiatus",
  "positive": "Valmis"
}
